/**
 * The version this bundle was built as — `release.version.revision`, worked
 * out by `scripts/version.mjs` and inlined by Vite's `define`. The reasoning
 * for the three numbers is there and in `tech-stack.md`; all the interface
 * needs is the string.
 *
 * Declared the way `sw.ts` declares `__BUILD__`: the identifier does not exist
 * at runtime, it is replaced in the source before the bundle is written.
 */
declare const __VERSION__: string;

export const version = __VERSION__;
